import { LinearProgress, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { cloneElement, useEffect, useState } from "react";
import Slide from "@mui/material/Slide";

export default function TilausTab_TabCell({
  isLoading = false,
  isActive = false,
  disabled = false,
  subtitle = "",
  width = 65,
  iconSize = 22,
  icon,
  title,
  tooltipTitle = undefined,
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  // set once to isLoaded when isLoading is false
  useEffect(() => {
    // get a random number between 300 and 1100
    const randomTime = Math.floor(Math.random() * 800) + 200;
    setTimeout(() => {
      if (!isLoading) setIsLoaded(true);
    }, randomTime);
  }, [isLoading]);

  const showSubTitle = isLoaded && (subtitle ? true : false);

  const styles = {
    disabledOpacity: {
      opacity: disabled ? 0.6 : 1,
    },
  };

  return (
    <>
      <Tooltip
        disableInteractive
        title={tooltipTitle !== undefined ? tooltipTitle : title}
        placement="top"
        arrow
        aria-label={title}>
        <div style={styles.disabledOpacity}>
          <div className="spaceBetween" style={{ gap: 6 }}>
            <div style={{ width: iconSize, height: iconSize }}>
              {cloneElement(icon, {
                style: { height: "100%", width: "100%" },
              })}
            </div>
            <div className="onlyWide" style={{ position: "relative" }}>
              <div style={{ width: width }}>
                <Typography
                  variant="h7"
                  color="primary"
                  sx={{
                    fontWeight: isActive ? "bold" : "normal",
                    position: "absolute",
                    top: showSubTitle ? -15 : -8,
                    left: 0,
                    transition: "all 0.6s ease",
                  }}>
                  {title}
                </Typography>
              </div>
              {showSubTitle && (
                <div style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                  <Slide direction="up" in={showSubTitle || false} mountOnEnter unmountOnExit>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: isActive ? "bold" : "normal",
                        position: "absolute",
                        top: 0,
                        left: 1,
                      }}>
                      {subtitle}
                    </Typography>
                  </Slide>
                </div>
              )}
            </div>
          </div>
          {isLoading && (
            <div style={{ position: "absolute", opacity: 0.4, width: width, bottom: "5px" }}>
              <LinearProgress sx={{ height: "2px" }} />
            </div>
          )}
        </div>
      </Tooltip>
    </>
  );
}

TilausTab_TabCell.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isLoading: PropTypes.bool,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.number,
  iconSize: PropTypes.number,
  tooltipTitle: PropTypes.string,
};
